module.exports = __webpack_public_path__ + "img/header.438e7d8b.jpg";